module.exports = __webpack_public_path__ + "img/Subtraction 7.646d0619.png";